import styled from 'styled-components'

import TokenOriginal from 'components/Token'
import ConfirmButton from 'components/Buttons/ConfirmButton'

import tokenWhite from 'images/tokenWhite.svg'
import resume from 'images/resume.svg'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	
	position: relative;
	background: #ffffff;
	border-radius: 16px;
	padding: 32px 24px;
	color: #333333;
	font-weight: 400;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
	border: 1px solid #e0e0e0;
	max-width: 480px;
	width: 100%;
	margin: 0 auto;
	
	@media (max-width: 768px) {
		padding: 24px 20px;
		margin: 16px;
		width: calc(100% - 32px);
	}
	
	@media (max-width: 465px) {
		padding: 20px 16px;
		border-radius: 12px;
	}
	
	.subtitle {
		margin-top: 12px;
		font-size: 14px;
		line-height: 1.4;
		color: #666666;
		text-align: center;
		font-weight: 400;
		
		@media (max-width: 465px) {
			font-size: 13px;
			margin-top: 10px;
		}
	}
	
	.valueProps {
		margin-top: 24px;
		display: flex;
		flex-direction: column;
		gap: 8px;
		
		@media (max-width: 465px) {
			margin-top: 20px;
			gap: 6px;
		}
	}
	
	.valueProp {
		font-size: 14px;
		font-weight: 400;
		color: #333333;
		display: flex;
		align-items: flex-start;
		line-height: 1.4;
		
		@media (max-width: 465px) {
			font-size: 13px;
		}
	}
	
	.explanation {
		margin-top: 16px;
		font-size: 14px;
		line-height: 1.5;
		color: #333333;
		text-align: left;
		font-weight: 400;
		
		@media (max-width: 465px) {
			font-size: 13px;
			margin-top: 14px;
		}
		
		&:first-of-type {
			margin-top: 20px;
			
			@media (max-width: 465px) {
				margin-top: 18px;
			}
		}
	}
	
	.additionalInfo {
		margin-top: 16px;
		font-size: 14px;
		line-height: 1.5;
		color: #333333;
		text-align: left;
		font-weight: 400;
		
		@media (max-width: 465px) {
			font-size: 13px;
			margin-top: 14px;
		}
	}
	
	.firstTokens {
		margin: 24px 0;
		font-size: 16px;
		font-weight: 600;
		color: #13CA82;
		text-align: center;
		
		@media (max-width: 465px) {
			font-size: 15px;
			margin: 20px 0;
		}
	}
`

export const TokenRow = styled.div`
	margin: 28px 0 24px 0;
	font-weight: 600;
	font-size: 16px;
	color: #0B4598;
	
	div, & {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	@media (max-width: 465px) {
		font-size: 14px;
		margin: 24px 0 20px 0;
	}
	
	.equals {
		margin: 0 16px;
		font-size: 20px;
		color: #999999;
		
		@media (max-width: 465px) {
			margin: 0 12px;
			font-size: 18px;
		}
	}
`

export const TokenIcon = styled.img.attrs({
	src: tokenWhite,
})`
	width: 28px;
	height: 20px;
	margin-right: 10px;
	filter: brightness(0) saturate(100%) invert(21%) sepia(94%) saturate(1853%) hue-rotate(207deg) brightness(95%) contrast(98%);
	
	@media (max-width: 465px) {
		width: 24px;
		height: 18px;
		margin-right: 8px;
	}
`

export const ResumeIcon = styled.img.attrs({
	src: resume,
})`
	width: 28px;
	height: 20px;
	margin-right: 10px;
	filter: brightness(0) saturate(100%) invert(21%) sepia(94%) saturate(1853%) hue-rotate(207deg) brightness(95%) contrast(98%);
	
	@media (max-width: 465px) {
		width: 24px;
		height: 18px;
		margin-right: 8px;
	}
`

export const Token = styled(TokenOriginal)`
	pointer-events: none;
	margin: 0;
	border: 2px solid #13CA82;
	background: #f8fffe;
	
	.top {
		color: #13CA82 !important;
		font-weight: 600 !important;
	}
	
	.bottom {
		color: #13CA82 !important;
		font-weight: 700 !important;
		font-size: 18px !important;
		
		@media (max-width: 465px) {
			font-size: 16px !important;
		}
	}
`

export const HorizontalSeparator = styled.div`
	border-top: 1px solid #e0e0e0;
	margin: 32px 0;
	
	@media (max-width: 465px) {
		margin: 24px 0;
	}
`

export const GotItButton = styled(ConfirmButton)`
	padding: 14px 32px !important;
	background: #0B4598 !important;
	color: #ffffff !important;
	align-self: center;
	border-radius: 25px;
	border: none !important;
	font-weight: 600 !important;
	font-size: 16px !important;
	min-width: 120px;
	box-shadow: 0 2px 8px rgba(11, 69, 152, 0.3);
	transition: all 0.2s ease;
	
	&:hover {
		background: #094080 !important;
		box-shadow: 0 4px 12px rgba(11, 69, 152, 0.4);
		transform: translateY(-1px);
	}
	
	&:active {
		transform: translateY(0);
		box-shadow: 0 2px 6px rgba(11, 69, 152, 0.3);
	}
	
	@media (max-width: 465px) {
		padding: 12px 24px !important;
		font-size: 15px !important;
		min-width: 100px;
	}
`
